
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationReadyForFinalPayment extends Mixins(OperationComponentMixin) {
  get sal(): boolean {
    return this.operationChild?.sal === true;
  }

  get readyForSal1(): boolean {
    return this.operationChild?.readyForSal1 === true;
  }
  get readyForSal1Date(): Date | null {
    return this.operationChild?.readyForSal1Date ?? null;
  }

  get readyForSal2(): boolean {
    return this.operationChild?.readyForSal2 === true;
  }
  get readyForSal2Date(): Date | null {
    return this.operationChild?.readyForSal2Date ?? null;
  }

  get readyForFinalPayment(): boolean {
    return this.operationChild?.readyForFinalPayment === true;
  }
  get readyForFinalPaymentDate(): Date | null {
    return this.operationChild?.readyForFinalPaymentDate ?? null;
  }

  get tooltip(): string {
    if (this.sal) {
      // Modalità SAL
      if (this.readyForSal1
        && !this.readyForSal2
        && !this.readyForFinalPayment) return `Pronto per la fatturazione SAL1 (${moment(this.readyForSal1Date).format('L')})`;

      if (this.readyForSal2
        && !this.readyForFinalPayment) return `Pronto per la fatturazione SAL2 (${moment(this.readyForSal2Date).format('L')})`;

      if (this.readyForFinalPayment) return `Pronto per la fatturazione finale (${moment(this.readyForFinalPaymentDate).format('L')})`;

      return 'Non ancora pronto per la fatturazione (modalità SAL)';
    }

    if (!this.readyForFinalPayment) return 'Non ancora pronto per la fatturazione finale';

    return this.readyForFinalPaymentDate
      ? `Pronto per la fatturazione finale (${moment(this.readyForFinalPaymentDate).format('L')})`
      : 'Pronto per la fatturazione finale';
  }

  get color(): string {
    if (this.sal) {
      // Modalità SAL
      return this.readyForSal1 || this.readyForSal2 || this.readyForFinalPayment
        ? 'statusDone' : 'grey lighten-2';
    }
    return this.readyForFinalPayment ? 'statusDone' : 'grey lighten-2';
  }

  get tooltipColor(): string {
    if (this.sal) {
      // Modalità SAL
      return this.readyForSal1 || this.readyForSal2 || this.readyForFinalPayment
        ? 'success' : 'error';
    }
    return this.readyForFinalPayment ? 'success' : 'error';
  }

  get columnClass(): string {
    if (this.operationChild?.flatTasks.includes('R=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('R=e')) return 'error';
    if (this.operation?.readyForFinalPayment === true) return 'completed';
    return '';
  }

  get icon(): string {
    if (this.sal) {
      // Modalità SAL
      if (this.readyForFinalPayment) return 'mdi-circle-slice-8';
      if (this.readyForSal1 && this.readyForSal2) return 'mdi-circle-slice-5';
      if (this.readyForSal1 || this.readyForSal2) return 'mdi-circle-slice-3';
      return 'mdi-alpha-s-circle-outline';
    }
    return this.readyForFinalPayment ? 'mdi-circle' : 'mdi-circle-outline';
  }

  onEdit() {
    console.log('OperationReadyForFinalPayment: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
